export const getLengthOrErrorText = (error?: string, len?: number, limit?: number) => {
  if (!!error) return error;
  return `${len ?? 0}/${limit ?? 0}`;
};
